module.exports = __webpack_public_path__ + "img/logo.912d8989.svg";